import axios from "axios"

export const AxiosInstance = axios.create({
    baseURL: "https://hunt-amazon-finds-back-end.onrender.com"
})

// http://localhost:5001/
// https://huntamazonfinds2-umgzkdi8.b4a.run/
// https://hunt-amazon-finds-back-end.onrender.com